import { createGlobalStyle } from 'styled-components';

const GlobalStyles = createGlobalStyle`
  *, *::before, *::after { box-sizing: border-box; margin: 0; padding: 0; }

  @import url('https://fonts.googleapis.com/css2?family=Inter:wght@400;500;600;700;800;900&display=swap');

  html { font-size: 16px; }

  body {
    font-family: 'Inter', -apple-system, BlinkMacSystemFont, sans-serif;
    background: #F5F5F5;
    color: #1A1A1A;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
  }

  a { color: inherit; text-decoration: none; }
  button { font-family: inherit; cursor: pointer; }
  input, textarea, select { font-family: inherit; }

  ::-webkit-scrollbar        { width: 6px; height: 6px; }
  ::-webkit-scrollbar-track  { background: transparent; }
  ::-webkit-scrollbar-thumb  { background: #D4B8A8; border-radius: 3px; }
  ::-webkit-scrollbar-thumb:hover { background: #BC9979; }

  ::selection { background: rgba(188,153,121,0.25); }

  /* Shared Service Catalog table language for module and report tables. */
  table {
    width: 100%;
    border-collapse: collapse;
    background: #FFFFFF;
    font-size: 13px;
  }
  table thead {
    background: #FAFAFA;
    border-bottom: 1.5px solid #F0F0F0;
  }
  table th[class] {
    padding: 12px 16px;
    color: #9E9E9E;
    font-size: 11px;
    font-weight: 700;
    letter-spacing: .5px;
    text-transform: uppercase;
    white-space: nowrap;
    vertical-align: middle;
  }
  table td[class]:not([colspan]) {
    padding: 14px 16px;
    color: #2D3142;
    vertical-align: middle;
  }
  table tbody tr {
    border-bottom: 1px solid #F5F5F5;
    transition: background .15s;
  }
  table tbody tr:last-child { border-bottom: 0; }
  table tbody tr:hover { background: #FAFAFA; }
`;

export default GlobalStyles;
